import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import api, { API } from "@/lib/api";
import { useAuth, hasSession } from "@/context/AuthContext";

const DEFAULT_CAMP = {
  camp_name: "",
  street: "",
  postal_city: "",
  country: "",
  phone: "",
  email: "",
  website: "",
  gps: "",
  vat_number: "",
  bank_name: "",
  bank_account: "",
  bank_bic: "",
  footer_extra: "",
  opening_hours: [],
  hour_seasons: [],
  currency: "EUR",
  vat_rate: 21,
  tourist_tax: 0,
  default_lang: "nl",
  logo_file_id: null,
  logo_tent_file_id: null,
  emergency: [],
  info_items: {},
  plan_w: 2000,
  plan_h: 1413,
  plan_unit: "px",
};

const Ctx = createContext({ camp: DEFAULT_CAMP, reload: () => {} });

export const logoUrl = (camp, which = "main") => {
  const id = which === "tent" ? camp?.logo_tent_file_id : camp?.logo_file_id;
  if (id) return `${API}/public/logo?which=${which}&v=${id}${camp?.tenant_id ? `&tenant=${camp.tenant_id}` : ""}`;
  return `${process.env.PUBLIC_URL || ""}/print/${which === "tent" ? "logo-tent" : "logo"}.png`;
};

export function SettingsProvider({ children }) {
  const [camp, setCamp] = useState(DEFAULT_CAMP);

  const reload = useCallback(async () => {
    const path = hasSession() ? "/settings" : "/public/settings";
    try {
      const { data } = await api.get(path);
      setCamp((c) => ({ ...c, ...data }));
      // afmeld-bestemming onthouden (demo-omgeving stuurt terug naar de bedrijfswebsite)
      if (data.logout_url) localStorage.setItem("cb_logout_url", data.logout_url);
      else localStorage.removeItem("cb_logout_url");
    } catch (e) { console.warn("Instellingen ophalen mislukt, standaardwaarden gebruikt", e?.message); }
  }, []);

  const { user } = useAuth();
  useEffect(() => { reload(); }, [reload, user]);

  return <Ctx.Provider value={{ camp, reload }}>{children}</Ctx.Provider>;
}

export const useCamp = () => useContext(Ctx);
